'use client';

import { DailyOverview } from './DailyOverview';
import { HistoryChart } from './HistoryChart';
import { InsightsSnapshot } from './InsightsSnapshot';
import { InsightsData } from './useWatchlistInsights';

interface InsightsContentProps {
  data: InsightsData;
  isCryptoOnly: boolean;
  isLoadingChart: boolean;
  isLoadingMix: boolean;
}

export const InsightsContent = ({
  data,
  isCryptoOnly,
  isLoadingChart,
  isLoadingMix,
}: InsightsContentProps) => (
  <div className="overflow-hidden rounded-lg">
    <DailyOverview stats={data.stats} />
    <HistoryChart chartOptions={data.chartOptions} isLoadingChart={isLoadingChart} />
    <InsightsSnapshot
      stats={data.stats}
      pieConfigs={data.pieConfigs}
      isCryptoOnly={isCryptoOnly}
      isLoadingMix={isLoadingMix}
    />
  </div>
);
